module.exports = __webpack_public_path__ + "static/img/mini-app-qrcode.a65a3dd2.jpg";